<template>
<div>
  <b-button @click="showForm = !showForm" variant="link">{{text}}</b-button>
  <b-modal id="modal-1"
    title="Attendance Form"
    v-model="showForm"
    size="xl"
    :lazy="true"
     @ok="handleOk"
    @cancel="handleCancel">
    <b-input-group class="mb-2">
      <b-form-input
        placeholder="Search"
        v-model="search"></b-form-input>
      <b-input-group-append>
        <b-button @click="search = ''">
          <b-icon icon="X" ></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-card v-for="u in filteredUsers" :key="u.user.id"
      :sub-title="u.user.name"
      class="mb-1">
      <b-row>
        <b-col>
          <b-form-group
            label="Notes From NetSuite">
            <b-form-textarea v-model="u.instructorNotes" readonly></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col>
           <b-form-group
            label="Attendance Notes">
            <b-form-textarea v-model="u.attendanceNotes"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <strong class="text-muted">Status:</strong> {{u.status}}
        </b-col>
        <b-col>
          <strong class="text-muted">eBook Serial #:</strong>{{u.trackingNumber}}
        </b-col>
        <b-col>
          <div class="text-right">
              <b-form-radio-group
                id="btn-radios-2"
                v-model="u.attendance"
                :options="['No Show', 'Complete', 'Incomplete']"
                button-variant="outline-primary"
                size="sm"
                name="radio-btn-outline"
                buttons
              ></b-form-radio-group>
            </div>
        </b-col>
      </b-row>
    </b-card>
    <b-table :items="users" :fields="fields" v-if="false">
      <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template v-slot:cell(name)="data">
            {{data.value}}
          </template>

          <template v-slot:cell(status)="data">
            {{data.value}}
          </template>

          <template v-slot:cell(instructorNotes)="data">
            <b-form-textarea v-model="data.item.instructorNotes" readonly></b-form-textarea>
          </template>

          <template v-slot:cell(attendanceNotes)="data">
            <b-form-textarea v-model="data.item.attendanceNotes"></b-form-textarea>
          </template>

          <template v-slot:cell(trackingNumber)="data">
            {{data.value}}
          </template>

          <template v-slot:cell(attendance)="data">
            <div class="text-right">
              <b-form-radio-group
                id="btn-radios-2"
                v-model="data.item.attendance"
                :options="['No Show', 'Complete', 'Incomplete']"
                button-variant="outline-primary"
                size="sm"
                name="radio-btn-outline"
                buttons
                stacked
              ></b-form-radio-group>
            </div>
          </template>
    </b-table>
  </b-modal>
</div>
</template>

<script>
import Api from '@/api/Api'

export default {
  props: {
    text: {
      type: String,
      default: 'Attendance Form'
    },
    courseId: {
      type: Number,
      default: 0,
      require: true
    }
  },
  data () {
    return {
      showForm: false,
      users: [],
      loading: true,
      search: '',
      fields: [
        { key: 'user.name', label: 'Student' },
        { key: 'status', label: 'Status' },
        { key: 'instructorNotes', label: 'Instructor Notes' },
        { key: 'attendanceNotes', label: 'Attendance Notes' },
        { key: 'trackingNumber', label: 'Tracking Number' },
        { key: 'attendance', label: '' }
      ]
    }
  },
  computed: {
    filteredUsers () {
      const vm = this
      if (vm.search !== '') {
        return vm.users.filter(u => u.user.name.toLowerCase().includes(vm.search.toLowerCase()))
      } else {
        return vm.users
      }
    }
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get(`Course/${vm.courseId}/Users?type=student`)
        .then((r) => {
          vm.users = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    handleOk () {
      // save attendance
      var vm = this
      vm.loading = true
      var promises = []
      for (var i = 0; i < vm.users.length; i++) {
        const a = {
          attendance: vm.users[i].attendance,
          attendanceNotes: vm.users[i].attendanceNotes
        }
        promises.push(Api().put(`Course/${vm.users[i].course.id}/Users/${vm.users[i].user.id}/Attendance/`, a))
      }
      Promise.all(promises)
        .then(() => {
          console.log('done')

          // Hide the modal manually
          this.$nextTick(() => {
            this.$bvModal.hide('modal-1')
          })
        })
        .finally(() => {
          vm.loading = false
        })
    },
    handleCancel () {

    }
  },
  watch: {
    showForm (value) {
      if (value) {
        this.loadData()
      }
    }
  }
}
</script>

<style scoped>

</style>
